import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import Toggle from "react-bootstrap-toggle";
import { get, isFunction, isArray, sortBy, groupBy } from "lodash";
import { bindActionCreators } from "redux";
import { guestListAction } from "../../actions/issuesListAction.actions";
import { connect } from "react-redux";
import { isValidArray } from "../../helper";
import { EMAIL_VALIDATE } from "../../validation";
import { Field } from "../../component";
import { toast } from "react-toastify";
import { ERROR_MSG, GROUP_CATEGORY } from "../../constant";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import NodalOfficer from "../../assets/nodal.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";

export class AgendaGuestList extends Component {
  state = {
    toggleActive: false,
    guestList: [],
    selectedIds: [],
    addedGuests: [],
    guest: { userName: "", emailType: "TO" },
    isChecked: true,
    selectedOption: "",
    isAllOptionSelect: false
  };
  isIssuesListLoaded = false;

  constructor(props) {
    super(props);
    this.myElementRef = React.createRef();
  }
  componentDidMount() {
    const { issueDetails, guestListDispatch } = this.props;
    isValidArray(issueDetails) && this.getGuestList(issueDetails);
    let projectIds = [];
    let issueIds = [];
    const params = {
      projectIds,
      issueIds
    };
    guestListDispatch(undefined, params);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { issueDetails, selectedGuests } = nextProps;
    const { issueDetails: oldIssuesDetails } = this.props;
    if (oldIssuesDetails.length !== issueDetails.length) {
      this.getGuestList(issueDetails);
    }
  }

  // guest list
  getGuestList = issuesList => {
    const { guestListDispatch } = this.props;
    console.log(issuesList);
    // {
    //     "projectIds" : [],
    //      "issueIds"  : []
    //   }
    let projectIds = [];
    let issueIds = [];
    issuesList.map(singleProject => {
      const projectSelectedIssues = singleProject.issuesSelected;
      if (
        isValidArray(projectSelectedIssues) &&
        projectSelectedIssues.length > 0
      ) {
        //loop through issues
        projectSelectedIssues.map(issue => {
          issueIds.push(issue.id);
        });
      } else {
        //Add project id in array
        projectIds.push(singleProject.id);
      }
    });
    const params = {
      projectIds,
      issueIds
    };
    console.log(params);
    // const ids = issuesList.map(issue => issue.id);
    guestListDispatch(undefined, params);
  };

  checkForCcLimit = (inst = []) => {
    return inst && inst.filter(item => item.emailType === "CC");
  };

  onToggle = value => {
    const { updatedSelectedGuest, selectedGuests } = this.props;
    let ccLimitArray = this.checkForCcLimit(selectedGuests);
    if (value.emailType === "CC") {
      const inst = isValidArray(selectedGuests) ? [...selectedGuests] : [];
      const checkField = value.userAddedGuest ? "_userId" : "userId";
      const guest = inst.find(val => val[checkField] === value[checkField]);
      if (guest) guest.emailType = guest.emailType === "TO" ? "CC" : "TO";
      isFunction(updatedSelectedGuest) &&
        updatedSelectedGuest(inst, "selectedGuests");
    } else {
      if (ccLimitArray && ccLimitArray.length < 48) {
        const inst = isValidArray(selectedGuests) ? [...selectedGuests] : [];
        const checkField = value.userAddedGuest ? "_userId" : "userId";
        const guest = inst.find(val => val[checkField] === value[checkField]);
        if (guest) guest.emailType = guest.emailType === "TO" ? "CC" : "TO";
        isFunction(updatedSelectedGuest) &&
          updatedSelectedGuest(inst, "selectedGuests");
      } else {
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.CC_LIMIT_EXCEED}</p>,
          errorToastStyle
        );
      }
    }
  };

  onChangeGuestEmail = value => {
    this.setState({
      guest: {
        userName: value,
        emailType: "TO",
        userAddedGuest: true,
        _userId: Math.random()
      }
    });
  };

  onValidate = () => {
    const {
      guest: { userName }
    } = this.state;
    const validateEmail = EMAIL_VALIDATE(userName);
    this.setState({
      error: {
        guest: {
          error: get(validateEmail, "error"),
          message: get(validateEmail, "error") && get(validateEmail, "message")
        }
      }
    });
  };

  onAddGuest = () => {
    const { guest, error } = this.state;
    if (get(error, "guest") && !get(error, "guest.error")) {
      this.setState(prevState => ({
        addedGuests: [...prevState.addedGuests, guest],
        guest: { userName: "", emailType: "TO" },
        error: { guest: { error: false, message: "" } }
      }));
    }
  };

  distinctOnBasisOfGroupId = (issue = []) => {
    const distinctGroup = {};
    const { selectedGuests } = this.props;
    (issue || []).forEach(value => {
      const guest =
        isValidArray(selectedGuests) &&
        selectedGuests.find(val => val.userId === value.userId);
      if (guest) value.emailType = guest.emailType;
      distinctGroup[value.guestCategory] =
        distinctGroup[value.guestCategory] || [];
      value.emailType = value.emailType || "TO";
      distinctGroup[value.guestCategory].push(value);
    });
    return Object.values(distinctGroup);
  };

  onChange = data => {
    const { updatedSelectedGuest, selectedGuests } = this.props;
    let index = null,
      idsClone = isArray(selectedGuests) ? [...selectedGuests] : [];
    idsClone.forEach((value, inx) => {
      if (data.userAddedGuest) {
        if (data.userId === value.userId) {
          index = inx;
        }
      } else {
        if (data.userId === value.userId) {
          index = inx;
        }
      }
    });
    Number.isInteger(index) ? idsClone.splice(index, 1) : idsClone.push(data);
    isFunction(updatedSelectedGuest) &&
      updatedSelectedGuest(idsClone, "selectedGuests");
  };

  selectOtherGuest = data => {
    const { updatedSelectedGuest, selectedGuests } = this.props;
    let index = null,
      idsClone = isArray(selectedGuests) ? [...selectedGuests] : [];
    idsClone.forEach((value, inx) => {
      if (data.userAddedGuest) {
        if (data._userId === value._userId) {
          index = inx;
        }
      } else {
        if (data._userId === value._userId) {
          index = inx;
        }
      }
    });
    Number.isInteger(index) ? idsClone.splice(index, 1) : idsClone.push(data);
    isFunction(updatedSelectedGuest) &&
      updatedSelectedGuest(idsClone, "selectedGuests");
  };

  handleCheckboxChange = (event, item, guest) => {
    const { value } = event.target;
    const isChecked = event.target.checked;
    const { selectedOption, isAllOptionSelect } = this.state;

    // Update the state for the current item
    const updatedIsAllOptionSelect = {
      ...isAllOptionSelect,
      [item]: !isAllOptionSelect[item]
    };

    // Filter guests based on the selected item
    const guestsToSelect = guest.filter(
      g => g.individualSelectAllIdentifierId === item
    );

    // Update the selected guests
    const { updatedSelectedGuest, selectedGuests } = this.props;
    const idsClone = isArray(selectedGuests) ? [...selectedGuests] : [];

    if (isChecked) {
      // Add all guests that are not already selected
      guestsToSelect.forEach(g => {
        const isActive = idsClone.find(
          selected => selected.userId === g.userId
        );
        if (!isActive) {
          idsClone.push(g);
        }
      });
    } else {
      // Remove all guests that are selected
      guestsToSelect.forEach(g => {
        const matchedSelected = idsClone.filter(
          selected => selected.userId === g.userId
        );
        matchedSelected.forEach(matched => {
          const index = idsClone.indexOf(matched);
          if (index !== -1) {
            idsClone.splice(index, 1);
          }
        });
      });
    }

    // Update the state and call the callback to update selectedGuests
    this.setState(
      {
        selectedOption: value,
        isAllOptionSelect: updatedIsAllOptionSelect
      },
      () => {
        isFunction(updatedSelectedGuest) &&
          updatedSelectedGuest(idsClone, "selectedGuests");
      }
    );
  };

  removeDuplicateObjects(arr) {
    return (
      arr &&
      arr.reduce((acc, curr) => {
        const duplicate = acc.find(item => item.userId === curr.userId);
        if (!duplicate) {
          acc.push(curr);
        }
        return acc;
      }, [])
    );
  }

  toCamelCase = str => {
    let words = str.split(/\s+/);
    let result = words[0].toLowerCase();
    for (let i = 1; i < words.length; i++) {
      let word = words[i];
      result += "_" + word.toLowerCase();
    }
    return result;
  };

  render() {
    const { guestListData, selectedGuests, originalGuestList } = this.props;
    console.log("guestListData", guestListData);
    const { addedGuests, guest, error, isChecked, newArray } = this.state;
    const guestData = get(guestListData, "data", []);

    originalGuestList(guestData);

    const uniqueGuestData = this.removeDuplicateObjects(guestData);

    const selectedGuestsData = Array.isArray(selectedGuests)
      ? selectedGuests
      : [];

    const uniqueIdGuest =
      guestData &&
      guestData.map(item => {
        return {
          ...item,
          uniqueId: item.guestCategory + "_" + item.userId,
          individualSelectAllIdentifierId: this.toCamelCase(
            item.guestCategory + "_" + item.groupName
          ),
          groupSelectAllIdentifierId: this.toCamelCase(
            item.guestCategory + "_" + item.groupName
          )
        };
      });

    const getGroupNamesBySelectAllIdentifierId = uniqueIdGuest => {
      let newArray = [];
      let groupNames = {};
      uniqueIdGuest &&
        uniqueIdGuest.forEach(guestObj => {
          const { groupSelectAllIdentifierId, groupName } = guestObj;
          if (groupNames.hasOwnProperty(groupSelectAllIdentifierId)) {
            if (!groupNames[groupSelectAllIdentifierId].includes(groupName)) {
              groupNames[groupSelectAllIdentifierId].push(groupName);
            }
          } else {
            groupNames[groupSelectAllIdentifierId] = [groupName];
          }
        });

      Object.keys(groupNames).forEach(key => {
        newArray.push({ [key]: groupNames[key][0] });
      });

      return newArray;
    };

    const removeDuplicateGuests = guestList => {
      const uniqueIds = new Set();
      const filteredList = [];

      guestList &&
        guestList.forEach(guest => {
          if (!uniqueIds.has(guest.uniqueId)) {
            uniqueIds.add(guest.uniqueId);
            filteredList.push(guest);
          }
        });

      return filteredList;
    };

    const guestGroupArray = getGroupNamesBySelectAllIdentifierId(uniqueIdGuest);
    const uniqueGuestList = removeDuplicateGuests(selectedGuests);

    const countUserofGroupandCateogry = (guest, item) => {
      let guestLength = guest && guest.length;
      let users = []; // Array to store objects with userId

      for (let i = 0; i < guestLength; i++) {
        if (guest[i].individualSelectAllIdentifierId === item) {
          users.push({ userId: guest[i].userId });
        }
      }

      return users;
    };

    return (
      <React.Fragment>
        {(this.distinctOnBasisOfGroupId(uniqueIdGuest) || []).map(
          (guest, index) => {
            return (
              <div class="select-list-container">
                <div class="selected-list">
                  <div>
                    {" "}
                    {GROUP_CATEGORY[get(guest[0], "guestCategory", "NA")]}{" "}
                  </div>
                </div>
                <Form className="guest-list-form pr-3 pl-3 pt-3">
                  <Form.Group controlId="checkbox">
                    {Object.keys(
                      groupBy(guest, "individualSelectAllIdentifierId")
                    ).map((item, index) => {
                      const getUserId = countUserofGroupandCateogry(
                        uniqueIdGuest,
                        item
                      );
                      const matchedUserIds = getUserId
                        .map(item => item.userId)
                        .filter(
                          userId =>
                            selectedGuests &&
                            selectedGuests.some(obj => obj.userId === userId)
                        );
                      const matchedObject = guestGroupArray.find(obj =>
                        obj.hasOwnProperty(item)
                      );
                      let matchedValue;
                      if (matchedObject) {
                        matchedValue = matchedObject[item];
                      }
                      const isCheckedSelectAll =
                        getUserId.length === matchedUserIds.length ||
                        (uniqueGuestList &&
                          uniqueGuestList.filter(
                            guest =>
                              guest.individualSelectAllIdentifierId === item
                          ).length ===
                            uniqueIdGuest.filter(
                              guest =>
                                guest.individualSelectAllIdentifierId === item
                            ).length);

                      return (
                        <div className={`guest-group-container`}>
                          <div className="select-all-container">
                            <div className="group-heading">{matchedValue}</div>
                            <div className="d-flex align-items-start guest-list">
                              <label key={index}>
                                {isCheckedSelectAll ? (
                                  <input
                                    className="select-all-input"
                                    type="checkbox"
                                    individualSelectAllIdentifierId={item}
                                    checked
                                    onChange={event =>
                                      this.handleCheckboxChange(
                                        event,
                                        item,
                                        guest
                                      )
                                    }
                                  />
                                ) : (
                                  <input
                                    className="select-all-input"
                                    type="checkbox"
                                    checked={false}
                                    individualSelectAllIdentifierId={item}
                                    onChange={event =>
                                      this.handleCheckboxChange(
                                        event,
                                        item,
                                        guest
                                      )
                                    }
                                  />
                                )}
                              </label>
                              <div className="select-toggle pl-2">
                                Select All
                              </div>
                            </div>
                          </div>

                          {groupBy(guest, "individualSelectAllIdentifierId")[
                            item
                          ].map((value, idx) => {
                            const isActive = (selectedGuests || []).find(
                              selected => selected.userId === value.userId
                            );
                            return (
                              <Form.Check
                                className={`form-checkbox mt-2 mb-3 d-flex justify-content-between guest-wrap-${idx} ${isActive &&
                                  "checked"}`}
                                key={`guestKey-${idx}`}
                              >
                                <Form.Check.Input
                                  type="checkbox"
                                  name="guest-list"
                                  individualSelectAllIdentifier={
                                    value.individualSelectAllIdentifierId
                                  }
                                  id={value.userId}
                                />
                                <Form.Check.Label
                                  value={value.userName}
                                  onClick={this.onChange.bind(this, value)}
                                  className="d-flex"
                                >
                                  {" "}
                                  <OverlayTrigger
                                    placement="bottom-start"
                                    overlay={
                                      <Tooltip
                                        id="tooltip-pdf"
                                        className={`issues-actions-tooltip tooltip-width ${""}`}
                                        placement="bottom-start"
                                      >
                                        {`${get(value, "designation", "NA")}`}
                                      </Tooltip>
                                    }
                                  >
                                    <div
                                      className="user-detail"
                                      style={{
                                        color: isActive ? "#356581" : "#525252"
                                      }}
                                    >
                                      {value.nodalOfficer ? (
                                        <Image
                                          src={NodalOfficer}
                                          className="nodal-officer-icon mr-1"
                                        />
                                      ) : null}
                                      {get(value, "userName", "NA")}
                                    </div>
                                  </OverlayTrigger>
                                </Form.Check.Label>
                                <Toggle
                                  className="user-toggle-btn"
                                  onClick={() => {
                                    this.onToggle(value);
                                  }}
                                  on={<span>TO</span>}
                                  off={<span>CC</span>}
                                  active={value.emailType === "TO"}
                                />
                              </Form.Check>
                            );
                          })}
                        </div>
                      );
                    }) || null}
                  </Form.Group>
                </Form>
              </div>
            );
          }
        )}
        <div class="select-list-container d-flex flex-column">
          <div class="selected-list">
            <div> Others </div>
          </div>
          <div className="guest-lists">
            <Form className="guest-list-form">
              <Form.Group controlId="checkbox">
                {(addedGuests || []).map(value => {
                  const isActive = (selectedGuests || []).find(
                    selected => selected.userName === value.userName
                  );
                  return (
                    <Form.Check
                      className={` form-checkbox d-flex mt-1 mb-3 justify-content-between ${isActive &&
                        "checked"}`}
                    >
                      <Form.Check.Input type="checkbox" name="guest-list" />
                      <Form.Check.Label
                        value={value.userName}
                        onClick={this.selectOtherGuest.bind(this, value)}
                      >
                        <span
                          className="user-detail"
                          style={{
                            color: isActive ? "#356581" : "#525252"
                          }}
                        >
                          {value.userName}
                        </span>
                      </Form.Check.Label>
                      <Toggle
                        onClick={() => {
                          this.onToggle(value);
                        }}
                        on={<span>TO</span>}
                        off={<span>CC</span>}
                        active={value.emailType === "TO"}
                      />
                    </Form.Check>
                  );
                }) || null}
              </Form.Group>
            </Form>
          </div>
          <Form className="add-other-guest-form">
            <Form.Group>
              <Field
                keyName="guest"
                type="text"
                placeholder="Enter guest email id"
                required
                onChange={this.onChangeGuestEmail}
                onError={this.onValidate}
                delay={1000}
                value={guest.userName}
                isInvalid={get(error, "guest.error")}
              />
              <Button
                className="btn-blue-invert disable-btn"
                onClick={this.onAddGuest}
                disabled={!this.state.guest.userName}
              >
                Add
              </Button>
              <Form.Control.Feedback type="invalid">
                {get(error, "guest.message")}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    guestListData: state.issueActionReducer.guestListData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      guestListDispatch: guestListAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgendaGuestList);
